import { errorMessage } from "utils/errorMessage";
import { canAccessRoute } from "utils/routeAccess";
import { useMutation } from "@apollo/client";
import { Card, Grid, Icon } from "@mui/material";
import CircularProgress from "@mui/material/CircularProgress";
import background from "assets/images/background.jpg";
import logo_ambiente from "assets/images/logo_ambiente.png";
import InstallPWA from "components/InstallButton";
import PageLayout from "components/LayoutContainers/EmpleadoLayout";
import SoftBox from "components/SoftBox";
import SoftButton from "components/SoftButton";
import SoftInput from "components/SoftInput";
import SoftTypography from "components/SoftTypography";
import { useState } from "react";
import { FaFish } from "react-icons/fa";
import { GiDeer } from "react-icons/gi";
import { Link } from "react-router-dom";
import routes from "routes";
import { login } from "services/login";
import ModalNuevaPass from "../components/ModalNuevaPass";
import ModalRecuperarPass from "../components/ModalRecuperarPass";
import ModalCambiarPass from "../ModalCambiarPass";

function SignIn() {
  const sha512 = require("js-sha512");

  const [username, setUsername] = useState("");
  const [password, setPassword] = useState("");
  const [emptyFields, setEmptyFields] = useState(false);
  const [errorLogin, setErrorLogin] = useState(null);
  const [openCambiarPass, setOpenCambiarPass] = useState(false);
  const [openRecuperarPass, setOpenRecuperarPass] = useState(false);
  const [openNuevaPass, setOpenNuevaPass] = useState(false);
  const [recoveryData, setRecoveryData] = useState(null);

  const [loginUser, { data, loading, error }] = useMutation(login);

  const handleChanges = (event) => {
    const { name, value } = event.target;
    if (name === "username") setUsername(value);
    if (name === "password") setPassword(value);
  };

  const handleLogin = (event) => {
    event.preventDefault();
    setErrorLogin(null);
    if (username !== "" && password !== "") {
      let history = JSON.parse(localStorage.getItem("history"));
      setEmptyFields(false);
      loginUser({
        variables: {
          userInput: {
            username: username,
            password: sha512(password),
          },
        },
      })
        .then((result) => {
          if (result.data.login !== null) {
            const loginData = result?.data?.login;

            if (loginData?.user?.tempPassword) {
              setOpenCambiarPass(true);
              return;
            }

            let rutasPrivadas = routes.filter((route) => route.permiso);
            let rutasPermitidas = rutasPrivadas.filter((route) => canAccessRoute(route, loginData?.user));
            localStorage.setItem("user", JSON.stringify({ token: loginData?.token }));
            localStorage.removeItem("history");
            if (loginData?.user?.tipoUser === "Administrador") {
              window.location.href = "/empresas";
              return;
            }
            if (rutasPermitidas.length > 0) {
              window.location.href = rutasPermitidas[0].route;
              return;
            } else {
              window.location.href = "/autogestion";
              return;
            }
          }
        })
        .catch((error) => {
          console.log(error);
          setErrorLogin(errorMessage(error));
        });
    } else {
      setEmptyFields(true);
    }
  };

  return (
    <PageLayout>
      <Card
        sx={{
          height: {
            xs: "100%",
            sm: "calc(100vh - 3rem)",
          },
        }}
      >
        <SoftBox
          sx={{
            height: "100%",
          }}
        >
          <Grid
            container
            justifyContent="center"
            alignItems="center"
            sx={{
              height: "100%",
            }}
          >
            <Grid
              item
              xs={12}
              sm={6}
              sx={{
                height: {
                  xs: "50%",
                  sm: "100%",
                },
              }}
            >
              <SoftBox
                height="100%"
                borderRadius="lg"
                sx={{
                  backgroundImage: ({
                    functions: { linearGradient, rgba },
                    palette: { gradients },
                  }) =>
                    background &&
                    `${linearGradient(
                      rgba(gradients.gobPrimary.main, 0.9),
                      rgba(gradients.gobPrimary.state, 0.6)
                    )}, url(${background})`,
                  backgroundSize: "cover",
                  backgroundPosition: "center",
                  backgroundRepeat: "no-repeat",
                  borderTopRightRadius: { xs: "lg", sm: 0 },
                  borderBottomRightRadius: 0,
                  borderBottomLeftRadius: { xs: 0, sm: "lg" },
                  minHeight: {
                    xs: "30vh",
                    sm: "100%",
                  },
                }}
                display="flex"
                flexDirection="column"
                justifyContent="center"
                alignItems="center"
              >
                <img src={logo_ambiente} alt="Gobierno de la Provincia de San Luis" width="40%" />
                <SoftBox mt={1}>
                  <SoftTypography
                    variant="h4"
                    fontWeight="bold"
                    color="white"
                    textAlign="center"
                    sx={{
                      display: {
                        xs: "none",
                        sm: "block",
                      },
                    }}
                  >
                    Sistema unificado de gestión
                    <br />
                    de residuos peligrosos
                  </SoftTypography>
                  <SoftTypography
                    variant="h5"
                    fontWeight="bold"
                    color="white"
                    textAlign="center"
                    sx={{
                      display: {
                        xs: "block",
                        sm: "none",
                      },
                    }}
                  >
                    Sistema de gestión de
                    <br />
                    residuos peligrosos
                  </SoftTypography>
                </SoftBox>
              </SoftBox>
            </Grid>
            <Grid
              item
              xs={12}
              sm={6}
              mt={{
                xs: 3,
                sm: 0,
              }}
            >
              <SoftBox display="flex" justifyContent="center" alignItems="center">
                <SoftBox
                  component="form"
                  role="form"
                  autoComplete="off"
                  p={3}
                  width={{
                    xs: "100%",
                    sm: "50%",
                  }}
                >
                  <SoftBox mb={1}>
                    <SoftTypography variant="h3" fontWeight="bold" color="primary">
                      Bienvenido
                    </SoftTypography>
                  </SoftBox>
                  <SoftTypography variant="body2" fontWeight="regular" color="text">
                    Inicia sesión para acceder al sistema de gestión de residuos peligrosos
                  </SoftTypography>
                  <SoftBox mb={2}>
                    <SoftBox mb={1} ml={0.5}>
                      <SoftTypography component="label" variant="caption" fontWeight="bold">
                        Usuario
                      </SoftTypography>
                    </SoftBox>
                    <SoftInput
                      type="text"
                      placeholder="Usuario"
                      name="username"
                      value={username}
                      onChange={handleChanges}
                      error={data && data.authenticateUser === null}
                      autoComplete="username"
                    />
                  </SoftBox>
                  <SoftBox mb={2}>
                    <SoftBox mb={1} ml={0.5}>
                      <SoftTypography component="label" variant="caption" fontWeight="bold">
                        Contraseña
                      </SoftTypography>
                    </SoftBox>
                    <SoftInput
                      type="password"
                      placeholder="Contraseña"
                      name="password"
                      value={password}
                      onChange={handleChanges}
                      error={data && data.authenticateUser === null}
                      autoComplete="current-password"
                    />
                  </SoftBox>
                  <SoftBox mt={4} mb={1}>
                    <SoftBox>
                      <SoftButton type="submit" color="primary" fullWidth onClick={handleLogin}>
                        {loading ? (
                          <CircularProgress color="inherit" size={17} />
                        ) : (
                          "Iniciar sesión"
                        )}
                      </SoftButton>
                    </SoftBox>
                    <SoftBox mt={2}>
                      <SoftButton
                        component={Link}
                        to={"/preinscripcion"}
                        color="gobSecondary"
                        fullWidth
                      >
                        Crear una cuenta &nbsp;
                        <Icon sx={{ fontWeight: "light" }}>arrow_forward</Icon>
                      </SoftButton>
                    </SoftBox>
                    <SoftBox mt={2}>
                      <SoftButton
                        variant="text"
                        color="gobSecondary"
                        fullWidth
                        onClick={() => setOpenRecuperarPass(true)}
                      >
                        Recuperar contraseña &nbsp;
                        <Icon sx={{ fontWeight: "light" }}>help</Icon>
                      </SoftButton>
                    </SoftBox>
                  </SoftBox>
                  <SoftBox mt={3} display="flex" justifyContent="center" alignItems="center">
                    {emptyFields && (
                      <SoftTypography variant="caption" color="error">
                        Debes ingresar un usuario y contraseña
                      </SoftTypography>
                    )}
                    {!emptyFields && error && (
                      <SoftTypography variant="caption" color="error">
                        {errorLogin}
                      </SoftTypography>
                    )}
                    {!emptyFields && errorLogin && error === undefined && (
                      <SoftTypography variant="caption" color="error">
                        {errorLogin}
                      </SoftTypography>
                    )}
                  </SoftBox>
                  {/* <SoftBox mt={3} textAlign="center">
                    <InstallPWA />
                  </SoftBox> */}
                  {/* <SoftBox
                    display="flex"
                    justifyContent="center"
                    flexDirection="column"
                    alignItems="center"
                    mt={2}
                    gap={2}
                  >
                    <SoftBox>
                      <SoftButton
                        component="a"
                        href="https://permisosdepesca.sanluis.gov.ar/Calendario_Ictico_2025.pdf"
                        target="_blank"
                        rel="noreferrer"
                        variant="gradient"
                        color="primary"
                      >
                        <Icon sx={{ fontWeight: "bold" }}>
                          <FaFish />
                        </Icon>
                        &nbsp; Ver Calendario Ictico
                      </SoftButton>
                    </SoftBox>
                    <SoftBox>
                      <SoftButton
                        component="a"
                        href="https://permisosdepesca.sanluis.gov.ar/Calendario_Cinegetico.pdf"
                        target="_blank"
                        rel="noreferrer"
                        variant="gradient"
                        color="gobSecondary"
                      >
                        <Icon sx={{ fontWeight: "bold" }}>
                          <GiDeer />
                        </Icon>
                        &nbsp; Calendario Cinegetico
                      </SoftButton>
                    </SoftBox>
                    <SoftBox>
                      <SoftButton
                        component="a"
                        href="https://permisosdepesca.sanluis.gov.ar/TemporadaCaza.pdf"
                        target="_blank"
                        rel="noreferrer"
                        variant="gradient"
                        color="primary"
                      >
                        <Icon sx={{ fontWeight: "bold" }}>calendar_today</Icon>
                        &nbsp; Temporada de Caza
                      </SoftButton>
                    </SoftBox>
                  </SoftBox> */}
                </SoftBox>
              </SoftBox>
            </Grid>
          </Grid>
          <ModalCambiarPass
            open={openCambiarPass}
            handleClose={() => setOpenCambiarPass(false)}
            data={data}
          />
          <ModalNuevaPass
            open={openNuevaPass}
            handleClose={() => setOpenNuevaPass(false)}
            idUser={recoveryData?.idUser}
            codigo={recoveryData?.codigo}
          />
          <ModalRecuperarPass
            open={openRecuperarPass}
            handleClose={() => setOpenRecuperarPass(false)}
            username={username}
            handleChangePass={(response) => {
              setRecoveryData(response);
              setOpenRecuperarPass(false);
              setOpenNuevaPass(true);
            }}
          />
        </SoftBox>
      </Card>
    </PageLayout>
  );
}

export default SignIn;
